import pdpZoom from './rbata.galleryZoom';
import startCloudinaryResponsive from '../utils/rbata.cloudinary';

const pdpSliderGallery = {
    document:                  $(document),
    pageBody:                  undefined,
    closeButton:               undefined,
    slider:                    undefined,
    sliderGalleryOverlay:      undefined,
    currentImage:              undefined,
    currentImageIndex:         undefined,
    touches:                   [],
    pinch:                     false,
    sliderGalleryImageSources: [],
    tns:                       undefined,
    cacheSelectors() {
        this.pageBody = this.document.find('body');
        this.sliderGalleryOverlay = this.pageBody.find('#js-pdp-zoom__overlay');
        this.sliderOverlay = this.pageBody.find('#js-pdp-zoom__overlay');
        this.closeButton = this.pageBody.find('#js-pdp-zoom__close');
        this.slider = this.pageBody.find('#js-pdp-zoom__slider');
    },

    buildTinySlider() {
        this.tns = tns({
            container:            '#js-pdp-zoom__slider',
            mode:                 'carousel',
            items:                1,
            startIndex:           pdpSliderGallery.currentImageIndex,
            nav:                  true,
            arrowKeys:            true,
            speed:                500,
            autoplayButtonOutput: false,
            lazyload:             true,
            mouseDrag:            true,
            controls:             false,
            loop:                 true, //infinite
            onInit:               () => {
                this.sliderOverlay.append(this.sliderControls());
                this.bindSliderControlsEvents();
                startCloudinaryResponsive();
            }
        });
        this.tns.events.on('indexChanged', (evt) => {
            // Set changed image for zoom
            pdpSliderGallery.currentImage = $(evt.slideItems[evt.displayIndex]).find('img');
            // If lise is changed, reset zoom and close it
            pdpZoom.resetZoomView();
            //Apply new image src to match current one on slider (Just for slider in overlay!)
            pdpZoom.updateSrc(pdpSliderGallery.sliderGalleryImageSources[evt.displayIndex - 1]);
        })
    },

    sliderControls: () => `<button type="button" class="pdp-zoom__slider-btn pdp-zoom__slider-btn--left">
                                <svg class="icon pdp-zoom__slider-icon">
                                    <use xlink:href="#icon-arrow-left"></use>
                                </svg>
                            </button>
                            <button type="button" class="pdp-zoom__slider-btn pdp-zoom__slider-btn--right">
                                <svg class="icon pdp-zoom__slider-icon">
                                    <use xlink:href="#icon-arrow-right"></use>
                                </svg>
                            </button>`,

    bindSliderControlsEvents() {
        this.sliderOverlay
            .on('click', '.pdp-zoom__slider-btn--left', evt => {
                evt.preventDefault();
                this.tns.goTo('prev');
            })
            .on('click', '.pdp-zoom__slider-btn--right', evt => {
                evt.preventDefault();
                this.tns.goTo('next');
            });
    },

    unbindSliderControlsEvents() {
        this.sliderOverlay
            .off('click', '.pdp-zoom__slider-btn--left')
            .off('click', '.pdp-zoom__slider-btn--right');
    },

    extractImageSources() {
        this.sliderGalleryImageSources = [];
        $('.pdp__slider-image--zoom').each((index, slide) => {
            const $slide = $(slide);
            let imageSource = null;

            if ($slide.find('.pdp__slider-video').length) {
                return;
            }

            if ($slide.parents('.pdp__gallery-slide').hasClass('tns-slide-cloned')) {
                return;
            }

            imageSource = $slide.data('src');
            this.sliderGalleryImageSources.push(
                    imageSource.replace(
                            `${alphatauri.config.cloudinaryAssetDetailPrefix}`,
                            `${alphatauri.config.cloudinaryAssetZoomPrefix}`
                    )
            );
        });
    },

    destroyTinySlider() {
        if (this.tns) {
            this.tns.destroy();
        }
        this.sliderOverlay.find('.pdp-zoom__slider-btn').remove();
        this.zoomOverlay(false);
        this.sliderGalleryImageSources = [];
        pdpSliderGallery.currentImageIndex = 0;
        this.unbindSliderControlsEvents();
        // mediaLazyLoad.refreshLazyLoad();
        startCloudinaryResponsive();
    },

    closeButtonActions() {
        this.destroyTinySlider();

        // Reset zoom overlay and hide it
        pdpZoom.resetZoomView();
    },

    zoomOverlay(show = true) {
        if (show) {
            this.sliderGalleryOverlay.addClass('pdp-zoom__overlay--active');
            this.pageBody.addClass('body-no-scroll');
        } else {
            this.sliderGalleryOverlay.removeClass('pdp-zoom__overlay--active');
            this.pageBody.removeClass('body-no-scroll');
        }
    },

    prepareSliderOverlay(event) {
        this.currentImage = $(event.currentTarget);
        this.currentImageIndex = this.currentImage.data('index');
        this.extractImageSources();
        this.addZoomSlides();
        this.zoomOverlay();
        this.buildTinySlider();

        // Prepare zoom overlay
        pdpZoom.init();
    },

    createSliderGallerySlide: imgSrc => `<div class="pdp-zoom__slide"><img class="pdp-zoom__image" src="${imgSrc}"></div>`,

    addZoomSlides() {
        this.slider.empty();
        for (let src of this.sliderGalleryImageSources) {
            this.slider.append(this.createSliderGallerySlide(src));
        }
    },

    bindHandler() {
        this.document.on('click', '.pdp__slider-image--zoom', event => this.prepareSliderOverlay(event));
        this.closeButton.on('click', () => this.closeButtonActions());
        this.document.on('keyup', evt => evt.which === 27 ? pdpSliderGallery.closeButtonActions() : false);

        // Show zoom overlay of event happened over slider
        this.sliderGalleryOverlay
            .on('wheel', (evt) => {
                if (evt.originalEvent.deltaY * -0.01 > 0) {
                    pdpZoom.showZoomOverlay();
                }
            })
            .on('touchstart', (evt) => {
                if (evt.touches.length === 2) {
                    pdpSliderGallery.pinch = true;
                }
            })
            .on('touchmove', (evt) => {
                if (pdpSliderGallery.pinch) {
                    const distance = Math.hypot(
                            evt.touches[0].pageX - evt.touches[1].pageX,
                            evt.touches[0].pageY - evt.touches[1].pageY
                    );

                    pdpSliderGallery.touches.push(distance);

                    if (pdpSliderGallery.touches.length === 2 && pdpSliderGallery.touches[0] < pdpSliderGallery.touches[1]) {
                        pdpZoom.showZoomOverlay();
                    }
                }
            })
            .on('touchend', () => {
                if (pdpSliderGallery.pinch) {
                    pdpSliderGallery.touches = [];
                    pdpSliderGallery.pinch = false;
                }
            })
    }
}

$(() => {
    if (pdpSliderGallery.document.find('#js-pdp__image-panel').length) {
        pdpSliderGallery.cacheSelectors();
        pdpSliderGallery.bindHandler();
    }
});
export default pdpSliderGallery;
